import React from "react";
import { Node } from "@xyflow/react";
import { useAtomValue } from "jotai";
import {
  agentAtomFamily_SUSPENDS,
  AgentFetchResult,
  DefaultNodeData,
  nodeAtomFamily,
} from "@zapier/canvas-state";
import { InstructionsDisplay } from "./InstructionsDisplay";
import styles from "./AgentPreview.module.css";

type Props = {
  nodeId: string;
};

/**
 * AgentPreview component displays information about an agent, including its instructions.
 * This is a read-only component that mimics the AICC agent details UI.
 */
export function AgentPreview({ nodeId }: Props) {
  const node = useAtomValue(nodeAtomFamily(nodeId)) as Node<DefaultNodeData>;

  const agentResult = useAtomValue(
    agentAtomFamily_SUSPENDS(node.data.agentId),
  ) as AgentFetchResult | null | undefined;
  const isSuccess = agentResult?.type === "success";
  const agent = isSuccess ? agentResult.data : undefined;

  if (!agent) {
    return null;
  }

  const { workflow } = agent;

  return (
    <div className={styles.container}>
      <InstructionsDisplay content={workflow.instructions} />
    </div>
  );
}
